import React from 'react';

// === components ===
import { Rules } from 'src/components';

const GameRulesPage: React.FC = () => {
  return <Rules />;
};

export default GameRulesPage;
